import axios from "axios";


const axiosInstance = axios.create({
  baseURL: "https://7gyutppcwl.execute-api.us-east-1.amazonaws.com/Prod",
  headers: {
    "Content-Type": "application/json",
  },
});

export const callApi = async ({
  method = "get",
  url,
  data = null,
  params = null,
  headers = {},
}) => {
  const response = await axiosInstance({
    method,
    url,
    data,
    params,
    headers,
  });
  return response.data;
};

export default axiosInstance;